import { useQuery } from '@tanstack/react-query';

import { getPlaidVerificationTokenLink } from '@arrived/api_v2';
import { AccountId, PlaidCreateTokenLinkResponse } from '@arrived/models';

import { UseQueryOptions } from '../../queries.utils';
import { plaidVerificationTokenLinkKeyFn } from '../accounts.keys';

export function usePlaidVerificationTokenLinkQuery(
  accountId: AccountId,
  options?: UseQueryOptions<PlaidCreateTokenLinkResponse>
) {
  return useQuery(plaidVerificationTokenLinkKeyFn(accountId), () => getPlaidVerificationTokenLink(accountId), {
    ...options,
    staleTime: options?.staleTime ?? 0,
  });
}
